import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    filterUnread: string;
    markAllAsRead: string;
    notificationsSettings: string;
    title: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for filtering the notifications list to only unread items */
            filterUnread: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationSheet.filterUnread?c=3t103slcf4xzj", defaultMessage: "Filter Unread" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label that marks all notifications as read */
            markAllAsRead: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationSheet.markAllAsRead?c=nhn60bl8k98r", defaultMessage: "Mark all as read" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Icon button label that navigates to notification settings from the notifications sheet */
            notificationsSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationSheet.notificationsSettings?c=3ey9zj8vpvsvj", defaultMessage: "Notifications Settings" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Sheet title shown at the top of the notifications panel */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationSheet.title?c=1bmhy5j8pv1g6", defaultMessage: "Notifications" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
